export default __webpack_public_path__ + "static/EBGaramond-Regular-676ddcee91bc2b17255f71647dd0cf10.woff2";